var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1026 17.1086L15.7981 13.8042C16.3735 12.8725 16.7213 11.7858 16.7213 10.6107C16.7213 7.23569 13.9856 4.5 10.6107 4.5C7.23569 4.5 4.5 7.23569 4.5 10.6107C4.5 13.9856 7.23569 16.7213 10.6107 16.7213C11.7858 16.7213 12.8725 16.3735 13.8032 15.7991L17.1086 19.1035C17.3746 19.3607 17.7311 19.5031 18.1011 19.4999C18.4711 19.4968 18.8251 19.3484 19.0866 19.0866C19.3482 18.8249 19.4965 18.4709 19.4995 18.1009C19.5025 17.7309 19.3599 17.3745 19.1026 17.1086ZM10.6107 14.8411C8.2745 14.8411 6.3802 12.9468 6.3802 10.6107C6.3802 8.2745 8.2745 6.3802 10.6107 6.3802C12.9468 6.3802 14.8411 8.2745 14.8411 10.6107C14.8411 12.9468 12.9468 14.8411 10.6107 14.8411Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.97f8fe70312fe82ac9073bb98cd7e3f8.svg";
export { ForwardRef as ReactComponent };